import React from "react"
import { Link, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"

import { BigHeaderLayout, Footer, RouterLink } from "core/components"
import urls from "core/urls"

const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: 570,
    margin: "0 auto",
    padding: theme.spacing(2),

    [theme.breakpoints.up("md")]: {
      padding: 0,
    },
  },

  title: theme.presets.title,
}))

function ScreensUserPasswordResetSuccess() {
  const classes = useStyles()
  return (
    <BigHeaderLayout isDataLoaded isErrorHappened={false}>
      <div className={classes.content}>
        <Typography variant="h1" align="center" className={classes.title}>
          НОВЫЙ ПАРОЛЬ СОЗДАН
        </Typography>
        <div>
          Пароль успешно изменен. Теперь вы можете&nbsp;
          <Link component={RouterLink} to={urls.login()}>
            авторизоваться
          </Link>{" "}
          в Вашем личном кабинете.
        </div>
      </div>
      <Footer />
    </BigHeaderLayout>
  )
}

export default ScreensUserPasswordResetSuccess
